const themeData = {
  data: {
    light: {
      id: "T_001",
      name: "Light",
      colors: {
        body: "#FFFFFF",
        text: "#000000",
        button: {
          text: "#FFFFFF",
          background: "#000000",
        },
        link: {
          text: "teal",
          opacity: 1,
        },
      },
      font: "Tinos",
    },
    dark: {
      id: "T_002",
      name: "Dark",
      colors: {
        body: "#000000",
        text: "#FFFFFF",
        button: {
          text: "#000000",
          background: "#FFFFFF",
        },
        link: {
          text: "teal",
          opacity: 1,
        },
      },
      font: "Roboto",
    },
    material: {
      id: "T_003",
      name: "Material",
      colors: {
        body: "#6a1b9a",
        text: "#ebdbf5",
        button: {
          text: "#6a1b9a",
          background: "#ebdbf5",
        },
        link: {
          text: "#ebdbf5",
          opacity: 0.8,
        },
      },
      font: "Abel",
    },
    sharp: {
      id: "T_004",
      name: "Sharp",
      colors: {
        body: "#ffeb3b",
        text: "#292500",
        button: {
          text: "#FFFFFF",
          background: "#292500",
        },
        link: {
          text: "#292500",
          opacity: 0.8,
        },
      },
      font: "Kufam",
    },
    calm: {
      id: "T_005",
      name: "Calm",
      colors: {
        body: "#80cbc4",
        text: "#002b24",
        button: {
          text: "#FFFFFF",
          background: "#002b24",
        },
        link: {
          text: "#002b24",
          opacity: 0.8,
        },
      },
      font: "Nunito Sans",
    },
    cherryBonBon: {
      id: "T_006",
      name: "Cherry Bon Bon",
      colors: {
        body: "#c62828",
        text: "#ffeeed",
        button: {
          text: "#c62828",
          background: "#ffeeed",
        },
        link: {
          text: "#ffeeed",
          opacity: 0.8,
        },
      },
      font: "Crimson Text",
    },
    seaWave: {
      id: "T_007",
      name: "Sea Wave",
      colors: {
        body: "#9be7ff",
        text: "#0d47a1",
        button: {
          text: "#ffffff",
          background: "#0d47a1",
        },
        link: {
          text: "#0d47a1",
          opacity: 0.8,
        },
      },
      font: "Ubuntu",
    },
  },
};

export default themeData;
